import Super from '../../core/button.gjs';
import styles from './secondary.module.scss';

export default class SpdsActionButtonSecondary extends Super {
  baseClass = 'spds-button spds-action-button';
  variantClass = 'spds-action-button-secondary';
  variantStyles = styles;
}
